/**
 * Add Component Dialog
 * Re-exports for backwards compatibility
 * @deprecated Import from "./add-component-dialog" folder instead
 */

export { AddComponentDialog } from "./add-component-dialog/add-component-dialog";
export type { AddComponentDialogProps } from "./add-component-dialog/add-component-types";
